import React from "react";
import SlideInOutAnimation from "../../util/SlideInOutAnimation";
import profileImage from "../../assets/profile-image-2.jpg";
import BgImage from "../../assets/bg-1.jpg";
import GreetingMessage from "../../util/GreetingMessage";

function HomePage() {
  return (
    <section className="relative flex flex-col md:flex-row items-center justify-center px-6 py-20 bg-black text-white">
      {/* Background image */}
      <div
        style={{ backgroundImage: `url(${BgImage})` }}
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20 grayscale"
      />

      {/* Image container with yellow accent */}
      <SlideInOutAnimation className="relative mb-10 md:mb-0 md:mr-24">
        {/* Yellow rectangle behind */}
        <div
          style={{
            animation: "slideInTopLeft 1s ease",
          }}
          className="absolute top-[-16px] left-[-16px] w-[50%] h-[50%] bg-yellow-500"
        ></div>
        <div
          style={{
            animation: "slideInBottomRight 1s ease",
          }}
          className="absolute bottom-[-16px] right-[-16px] w-[50%] h-[50%] bg-yellow-500"
        ></div>

        {/* Actual image */}
        <div className="relative w-72 h-84 overflow-hidden">
          <img
            src={profileImage}
            alt="Profile"
            className="w-full h-full object-cover scale-[1.2] hover:scale-[2] transition-transform duration-[0.7s] ease-in-out"
          />
        </div>
      </SlideInOutAnimation>

      {/* Text content */}
      <SlideInOutAnimation className="max-w-lg text-center md:text-left z-10">
        <h1 className="text-yellow-500 text-lg font-semibold mb-1">
          — <GreetingMessage style={{display: 'inline'}} className="text-yellow-500" /> from
        </h1>
        <h2 className="text-4xl md:text-5xl font-extrabold leading-tight mb-4">
          BIJAY PANDEY
        </h2>
        <p className="text-gray-300 mb-6">
          I’m an India based full stack developer with over 3.5 years of industry
          experience in building robust enterprise applications focused on
          crafting scalable, clean & user‑friendly experiences. I am passionate
          about building excellent software that improves the lives of those
          around me.
        </p>
        <a
          href="#about"
          className="inline-flex items-center justify-center bg-yellow-500 text-black font-medium rounded-full w-10 h-10 hover:bg-yellow-400 transition z-20"
        >
          →
        </a>
      </SlideInOutAnimation>

      {/* Blur bottom fade overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-b from-transparent to-black"></div>
    </section>
  );
}

export default HomePage;
